import { queryKeys as sharedQueryKeys } from '../../queryKeys';
import { queryClient } from '../queryClient';
import { creators } from './tokenDuck';

export const ACTIVE_ROLE_KEY = 'activeRole';

export const clearActiveRole = () => {
  globalThis.localStorage.removeItem(ACTIVE_ROLE_KEY);
};

export const clearAuth = dispatch => {
  dispatch(creators.clearToken());
  clearActiveRole();
  queryClient.removeQueries({ queryKey: [sharedQueryKeys.USER] });
};
